import { memo } from 'react';

import ShareFeedbackIconSVG from '@/assets/share-feedback-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IShareFeedbackIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={ShareFeedbackIconSVG} {...props} />
);

export const ShareFeedbackIcon = memo(IShareFeedbackIcon) as typeof IShareFeedbackIcon;
